import { Alert } from 'shared/mui/Alert/Alert';
import { Box } from 'shared/mui/Box';

type Props = {
  children: React.ReactNode;
};

export const MerchantShowCommissionsShowDialogAlert: React.FC<Props> = ({ children }) => {
  return (
    <Box p="0 24px 24px">
      <Alert severity="info">{children}</Alert>
    </Box>
  );
};
